import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import MessageBrokerContext from '../message-broker-provider/context';
function useMessageBrokerChannel(params) {
    const messageBrokerInstance = useContext(MessageBrokerContext);
    const { channelOptions, consumerFn, enabled = true, metadataRequired = false } = params;
    const [channel, setChannel] = useState(null);
    const [channelStatus, setChannelStatus] = useState();
    const [channelMetadata, setChannelMetadata] = useState(null);
    const channelOptionsRef = useRef(channelOptions);
    const consumerRef = useRef(consumerFn);
    const handleMetadataChange = useCallback((metadata) => {
        setChannelMetadata(metadata);
    }, []);
    const handleChannelStatusChange = useCallback((status) => setChannelStatus(status), []);
    if (!channel) {
        channelOptionsRef.current = channelOptions;
        consumerRef.current = consumerFn;
    }
    useEffect(() => {
        const createChannel = async () => {
            if (messageBrokerInstance) {
                try {
                    const { channelId, channelName } = channelOptionsRef.current;
                    const channelInstance = await messageBrokerInstance.createChannel({
                        ...channelOptionsRef.current,
                        channelName: channelName ?? `${channelId}_channel_name`,
                        consumerFn: consumerRef.current,
                        onMetadataChangeFn: metadataRequired ? handleMetadataChange : undefined,
                        onStatusChangeFn: handleChannelStatusChange,
                    });
                    setChannel(channelInstance);
                    setChannelMetadata(channelInstance?.getChannelMetadata());
                }
                catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('qmq Channel creation failed in hook', e);
                }
            }
        };
        if (!channel && enabled)
            createChannel();
    }, [
        channel,
        messageBrokerInstance,
        enabled,
        handleChannelStatusChange,
        handleMetadataChange,
        metadataRequired,
    ]);
    useEffect(() => {
        if (channel && consumerFn) {
            channel.addConsumer(consumerFn);
        }
        return () => {
            if (channel && consumerFn) {
                channel.removeConsumer(consumerFn);
            }
        };
    }, [channel, consumerFn]);
    useEffect(() => {
        return () => {
            channel?.removeMetadataChangeListner(handleMetadataChange);
            channel?.removeStatusChangeListner(handleChannelStatusChange);
        };
    }, [channel, handleChannelStatusChange, handleMetadataChange]);
    useEffect(() => {
        return () => {
            const { channelId, destroyOnUnmount } = channelOptionsRef.current;
            if (destroyOnUnmount) {
                messageBrokerInstance?.destroyChannel(channelId);
            }
        };
    }, [messageBrokerInstance]);
    return {
        channel,
        publish: channel?.publish,
        setChannelMetadata: channel?.setChannelMetadata,
        removeChannelMetadata: channel?.removeChannelMetadata,
        channelStatus,
        channelMetadata,
    };
}
export { useMessageBrokerChannel };
//# sourceMappingURL=use-message-brocker-channel.js.map